import { isDecimal } from '../values';

/**
 * User input → canonical decimal string ("12,50" → "12.5", " 007 " → "7"). Accepts the Slovak decimal comma and
 * spaces as thousands separators. Unparseable input is returned trimmed (the engine reports number.format).
 */
export function toCanonicalNumber(input: string): string {
  const compact = input.trim().replace(/\s+/g, '').replace(',', '.');
  if (compact === '') return '';
  const m = /^(-?)(\d+)(?:\.(\d+))?$/.exec(compact);
  if (!m) return input.trim();
  const sign = m[1] ?? '';
  const int = (m[2] ?? '0').replace(/^0+(?=\d)/, '');
  const frac = (m[3] ?? '').replace(/0+$/, '');
  const result = `${sign}${int}${frac ? `.${frac}` : ''}`;
  return result === '-0' ? '0' : result;
}

/** Canonical value → display text in the UI language (decimal comma in Slovak). */
export function displayNumber(value: unknown, lang: string): string {
  if (typeof value !== 'string') return '';
  return isDecimal(value) && lang === 'sk' ? value.replace('.', ',') : value;
}
